import React, {useEffect, useState, useRef} from 'react';
import * as d3 from "d3";
import {Card, Paper, Typography, CardHeader, CardContent, Button} from '@material-ui/core';
import {FaThermometerHalf} from 'react-icons/fa'
import {WiCloudy, WiHumidity} from 'react-icons/wi'
import {GiGooeyMolecule, GiDustCloud} from 'react-icons/gi'
import './App.css';

function Subheader({ label }){
    return (
        <form style={{display: "flex"}} onSubmit={() => window.open('https://gwsluftwaechter.blob.core.windows.net/public/Datenblatt_Luftwächter_GWS.pdf', '_blank')}>
            {label}<Button type='submit'> Datenblatt anzeigen </Button>
        </form>
    );
}

export default function Overview() {
    const timestampRef = useRef(0);
    const [timestamp, setTimestamp] = useState(new Date());
    const [device, setDevice] = useState({ 
        name:"", 
        serial:"", 
        type:"", 
        description:"", 
        location:"", 
        lat:"", 
        lon:"", 
        alt:"", 
        timestamp:"" 
    });
    const [values, setValues] = useState({
        gasen:[], 
        feinstaub:[], 
        luftdruck:[], 
        feuchtigkeit:[], 
        temperatur:[]
    });

    useEffect(() => {
        const interval = setInterval(function(){
        setTimestamp(new Date());
        }, 1000);
        return () => { window.clearInterval(interval); }
    }, []);
    
    useEffect(() => {
        let mounted = true;
        if (mounted){
            fetch('https://its-hilfsfunktionen.azurewebsites.net/api/luftwaechterLatestValues')
            .then( async ( response ) => {
            const gasen = [];
            const feinstaub = [];
            const temperatur = [];
            const feuchtigkeit=[];
            const luftdruck=[]; 

            const {device_specs:deviceSpecs, latest_values:lastValues} = await response.json();
            const {timestamp} = lastValues;
            for (const [key, value] of Object.entries(lastValues)){
                if(["NO2", "CO", "O3", "NO"].includes(key)) gasen.push({[`${key}`]: value})
                else if(["PM2.5", "PM10"].includes(key)) feinstaub.push({[`${key}`]: value})
                else if (["Air Temp."].includes(key)) temperatur.push({[`${key}`]: value})
                else if (["Air Hum."].includes(key)) feuchtigkeit.push({[`${key}`]: value})
                else if (["Air Pres."].includes(key)) luftdruck.push({[`${key}`]: value})
            };
            setValues({gasen, feinstaub, temperatur, feuchtigkeit, luftdruck});
            setDevice({...deviceSpecs, timestamp});
            // setDevice(lastValues)
            })
        };
        return () => { 
            mounted = false; 
            setDevice({ 
                name:"", serial:"", type:"", 
                description:"", location:"", 
                lat:"", lon:"", alt:"", 
                timestamp:"" 
            });  
        };
    },[timestampRef.current])
    
    if (timestamp.getMinutes() % 10 === 3) timestampRef.current = timestamp.getMinutes();
    
    return (
        <Card style={{ boxShadow:"0 8px 40px -12px rgba(0,0,0,0.3)", minWidth: 415, width:"70vw" }}>
        <CardHeader title={`Luftwächter® - Musterstandort bei Green Way Systems Baden-Baden`} subheader={Subheader({label: d3.timeFormat("%d.%m.%Y %H:%M:%S")(timestamp)})}/>
        <CardContent>      
            <div className="test">
            <Paper className="container">
            {/* <CardHeader component={FaThermometerHalf}/> */}
            {values.temperatur && values.temperatur.map((el, i) => {
                const [key, value] = Object.entries(el)[0];
                let label="";
                switch (key){case("Air Temp."): label = "Temperatur"; break;};
                return (
                <div className="data-frame" key={i}>
                    <div style={{display: "flex", alignItems:"center"}}>
                    <FaThermometerHalf/>
                    <Typography style={{ fontWeight:'bold'}}> {label} </Typography>
                    </div>
                    <Typography><span>{value}&nbsp;°C</span> </Typography>
                </div>
                );
            })}
            </Paper>
            <Paper className="container">
            {/* <CardHeader component={WiHumidity}/> */}
            {values.feuchtigkeit && values.feuchtigkeit.map((el, i) => {
                const [key, value] = Object.entries(el)[0];
                let label="";
                switch (key){case("Air Hum."): label = "Feuchtigkeit"; break;};
                return (  
                <div className="data-frame" key={i}>
                    <div style={{display: "flex", alignItems:"center"}}>
                    <WiHumidity/>
                    <Typography style={{ fontWeight:'bold'}}> {label} </Typography>
                    </div>
                    <Typography><span>{value}&nbsp;%</span> </Typography>
                </div>
                );
            })}
            </Paper>
            <Paper className="container">
            {/* <CardHeader component={WiCloudy}/> */}
            {values.luftdruck && values.luftdruck.map((el, i) => {
                const [key, value] = Object.entries(el)[0];
                let label="";
                switch (key){case("Air Pres."): label = "Luftdruck"; break;};
                return (  
                <div className="data-frame" key={i}>
                    <div style={{display: "flex", alignItems:"center"}}>
                    <WiCloudy/>
                    <Typography style={{ fontWeight:'bold'}}> {label} </Typography>
                    </div>
                    <Typography><span>{value}&nbsp;mbar</span> </Typography>
                </div>
                );
            })}
            </Paper>
            <Paper className="container">
            <CardHeader component={GiDustCloud}/>
            {values.feinstaub && values.feinstaub.map((el, i) => {
                const [key, value] = Object.entries(el)[0];
                let label="";
                switch (key){
                case("PM2.5"): label = "Feinstaub 2.5"; break;
                    case("PM10"): label = "Feinstaub 10"; break;
                };
                return (  
                <div className="data-frame" key={i}>
                    <Typography style={{ fontWeight:'bold'}}> {label} </Typography>
                    <Typography> 
                        <span>
                        {value}&nbsp;{'\xB5'}g/m{<sup>3</sup>}
                        </span> 
                    </Typography>
                </div>
                );
            })}
            </Paper>
            <Paper className="container">
            <CardHeader component={GiGooeyMolecule} />
            {values.gasen && values.gasen.map((el, i) => {
                const [key, value] = Object.entries(el)[0];
                let label="";
                switch (key){
                case("NO2"): label = "Stickstoffdioxid [NO2]"; break;
                case("CO"): label = "Kohlenstoffmonoxid [CO]"; break;
                case("O3"): label = "Ozon [O3]"; break;
                case("NO"): label = "Stickstoffmonoxid [NO]"; break;
                };
                return (  
                <div className="data-frame" key={i}>
                    <Typography style={{ fontWeight:'bold'}}> {label} </Typography>
                    <Typography> 
                        <span>
                        {value}&nbsp;{'\xB5'}g/m{<sup>3</sup>}
                        </span> 
                    </Typography>
                </div>
                );
            })}
            </Paper>
            </div>
            <Paper style={{boxShadow:"0 8px 40px -12px rgba(0,0,0,0.3)", display:'flex', flexDirection:'column', minWidth:350 ,width: '30vw', padding: 15, margin:"auto"}}>
                <div className="data-frame">
                    <Typography style={{fontWeight:'bold'}}>
                        Seriennummer
                    </Typography>
                    <Typography>
                        {device.name}
                    </Typography>
                </div>
                <div className="data-frame">
                    <Typography style={{fontWeight:'bold'}}>
                        Beschreibung
                    </Typography>
                    <Typography>
                        {`MOG100/${device.description}`}
                    </Typography>
                </div>
                <div className="data-frame">
                    <Typography style={{fontWeight:'bold'}}>
                        Ort
                    </Typography>
                    <Typography className="label location">
                    {device.location}
                    </Typography>
                </div>
                <div className="data-frame">
                    <Typography style={{fontWeight:'bold'}}>
                        Längengrad
                    </Typography>
                    <Typography>
                        {device.lat + '°'}
                    </Typography>
                </div>
                <div className="data-frame">
                    <Typography style={{fontWeight:'bold'}}>
                        Breitengrad
                    </Typography>
                    <Typography>
                        {device.lon + '°'}
                    </Typography>
                </div>
                <div className="data-frame">
                    <Typography style={{fontWeight:'bold'}}>
                        Höhe
                    </Typography>
                    <Typography>
                        {device.alt + ' m'}
                    </Typography>
                </div>
                <div className="data-frame">
                    <Typography style={{fontWeight:'bold'}}>
                        letzter Stand:
                    </Typography>
                    <Typography>
                        {device.timstamp===""?"":d3.timeFormat("%d.%m.%Y %H:%M")(d3.utcParse("%Y-%m-%d %H:%M:%S")(device.timestamp))}
                    </Typography>
                </div>
            </Paper>
        </CardContent>
    
        </Card>
    );
}